<!--
 * @message: 头像
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2021-01-18 11:36:14
 * @FilePath: \mrc-ess-fronted\src\components\MRC_ESS_StaffAvatar.vue
 * @最后编辑: Betway
 * @最后修改时间: 2021-12-09 14:27:49
-->
<template>
  <v-badge avatar bordered overlap color="red" v-model="temp">
    <template v-slot:badge>
      <div style="line-height: 20px">T</div>
    </template>
    <v-avatar
      :size="small ? 24 : size"
      :class="contentClass"
      :left="left"
      @click="triger"
      :tile="tile"
      :max-width="small ? 24 : size"
      :max-height="small ? 24 : size"
      :right="right"
      :rounded="rounded"
      :style="{
        border: border ? '1px solid rgba(0, 0, 0, 0.1)' : 'none',
        cursor: 'pointer',
      }"
      :color="color ? color : src && !isError ? 'transparent' : avatarColor"
    >
      <v-img
        v-if="src && !isError"
        :src="src"
        width="100%"
        height="100%"
        class="teansparent"
        @load="isError = false"
        @error="isError = true"
        :alt="$getCommonLangValue(staff_name)"
        aspect-ratio="1"
      >
        <template v-slot:placeholder>
          <v-sheet
            class="
              transparent
              max-width
              fill-height
              d-flex
              align-center
              justify-center
            "
          >
            <v-progress-circular
              :width="2"
              :size="small ? 12 : size / 2"
              color="primary"
              indeterminate
            ></v-progress-circular>
          </v-sheet>
        </template>
      </v-img>
      <!-- 
         :width="small ? 24 : Number(size)"
        :height="small ? 24 : Number(size)"
        :max-height="small ? 24 : Number(size)"
        :max-width="small ? 24 : Number(size)"
       -->
      <!-- <v-img
      v-else-if="src && isError"
      :src="errorimg"
      :alt="$getCommonLangValue(staff_name)"
      aspect-ratio="1"
    /> -->

      <span
        v-else
        class="white--text"
        :style="{
          fontSize: getFontSize(small ? 24 : size),
          lineHeight: (small ? 24 : size) + 'px',
        }"
        >{{ getName($getCommonLangValue(staff_name)) }}</span
      >
      <slot name="default" />
    </v-avatar>
  </v-badge>
</template>
<script>
import { mapGetters } from "vuex";
import errorimg from "@/assets/errorimg.png";
export default {
  name: "StaffAvatar",
  computed: {
    ...mapGetters(["companyLang", "staticZone", "AppInfo"]),
    curAppInfo() {
      return this.AppInfo ? JSON.parse(this.AppInfo) : null;
    },
    temp: {
      get() {
        return this.isTemp;
      },
      set(val) {
        return val;
      },
    },
  },
  props: {
    size: { default: 36, type: [String, Number] },
    contentClass: { default: "white--text", type: String },
    src: { default: null, type: [String, Object] },
    src2: { default: null, type: [String, Object] },
    left: { default: false, type: Boolean },
    border: { default: false, type: Boolean },
    tile: { default: false, type: Boolean },
    right: { default: false, type: Boolean },
    isTemp: { default: false, type: [Boolean, Number] },
    small: { default: false, type: [Boolean, Number] },
    color: { default: undefined, type: String },
    rounded: { default: undefined, type: [Boolean, String] },
    staff_name: { default: null, type: [String, Object, Number, Array] },
  },
  data() {
    return { avatarColor: null, isError: false, errorimg: errorimg };
  },
  watch: {
    isError(val) {
      // console.log("图片错误:" + val);
      this.$emit("error", val);
    },
    src(val) {
      //   上传之后重置错误状态
      if (val) this.isError = false;
    },
  },
  mounted() {
    this.avatarColor = this.$oneColors;
  },
  methods: {
    triger(e) {
      this.$emit("click", e);
    },
    getFontSize(size) {
      switch (Number(size)) {
        case 96:
          return "57px";
          break;
        case 72:
          return 72 / 1.69 + "px";
          break;
        case 64:
          return "38px";
          break;
        case 48:
          return "28px";
          break;
        case 36:
          return 36 / 1.69 + "px";
          break;
        case 32:
          return "19px";
          break;
        case 24:
          return "14px";
          break;
        case 16:
          return "9px";
          break;
        default:
          return Number(size) / 1.69 + "px";
          break;
      }
    },
    getName: function (staff_name) {
      if (!staff_name) return "";
      if (typeof staff_name != "string") return "";
      if (staff_name.length < 2) return staff_name;
      if (staff_name.length >= 2)
        if (/.*[\u4e00-\u9fa5]+.*$/.test(staff_name.substring(0, 2))) {
          return staff_name.split("")[0].toUpperCase();
        } else {
          return staff_name.split("")[0].toUpperCase();
          // 改為取首位字幕buglist 802 mel
          // return (
          //   staff_name.split("")[0].toUpperCase() +
          //   staff_name.split("")[1].toLowerCase()
          // );
        }
    },
  },
};
</script>